<mat-form-field class="fw" appearance="outline">
  <mat-label>Clinical Record</mat-label>
  <mat-select
    id="integrationSelect"
    #integrationSelect
    [formControl]="selectedControl"
    (selectionChange)="onChange($event)"
  >
    @if (selected) {
      <mat-select-trigger>
        {{ selected["name"] }}
        @if (selected["company"]) {
          <span> - {{ selected["company"]["name"] }}</span>
        }
      </mat-select-trigger>
    }
    @for (integration of integrations; track integration) {
      <div class="clinical-records">
        <mat-option
          [value]="integration"
          [disabled]="
            exportableTo.indexOf(integration.id) === -1 && !ignoreExportableTo
          "
        >
          <div class="ml-2 texts">
            <div class="option_title">
              {{ integration.name }}
              @if (
                exportableTo.indexOf(integration.id) === -1 &&
                !ignoreExportableTo
              ) {
                <span> (Already exported)</span>
              }
            </div>
            <div class="option_subtitle">{{ integration.company.name }}</div>
          </div>
        </mat-option>
      </div>
    }
  </mat-select>
</mat-form-field>
<mat-form-field class="fw" appearance="outline">
  <mat-label>Select a service</mat-label>
  <mat-select
    id="serviceSelect"
    #serviceSelect
    [formControl]="serviceControl"
    (selectionChange)="onServiceChange($event)"
  >
    @for (service of services; track service) {
      <div>
        <mat-option [value]="service">
          <div class="ml-2 texts">
            <div class="option_title">{{ service.name }}</div>
          </div>
        </mat-option>
      </div>
    }
  </mat-select>
</mat-form-field>
